export enum VossPackageType {
    SaaS = 0,
    Transactions = 1,
    OnPrem = 2,
    Consulting = 3,
    Mixed = 4,
}

export const VossPackageTypeText: Record<VossPackageType, string> = {
    [VossPackageType.SaaS]: 'SaaS',
    [VossPackageType.Transactions]: 'Transactions',
    [VossPackageType.OnPrem]: 'OnPrem',
    [VossPackageType.Consulting]: 'Consulting',
    [VossPackageType.Mixed]: 'Mixed',
};
